import { SxProps, Typography } from '@mui/material';
import React from 'react';
import { vars } from '../../../../Theme';
import AppTooltip from '../../../General/AppTooltip/AppTooltip';

/** Base tag text styles. */
const textSx: SxProps = {
    borderRadius: 2.5,
    color: vars.white,
    lineHeight: 1,
    height: 20,
    flex: 0,
    py: 0.5,
    px: 1,
    mr: 1,
};

interface IProjectRowTagProps {
    moduleAbbreviation: string;
    tagColor: string;
    tooltipTitle: string;
}

/**
 * Component that shows a project's type as a colored 'tag'.
 */
export default ({ moduleAbbreviation, tagColor, tooltipTitle }: IProjectRowTagProps) => {
    return (
        <AppTooltip title={tooltipTitle ?? ''} placement='top-start'>
            <Typography
                variant='h6'
                sx={{
                    fontSize: 12,
                    ...textSx,
                    backgroundColor: tagColor,
                }}
            >
                {moduleAbbreviation}
            </Typography>
        </AppTooltip>
    );
};
